import * as ACTIONS from './actionTypes';

export const reducer = (state, { type, payload }) => {
  switch (type) {
    case ACTIONS.COMPANY_SEARCH_REQUESTED:
      return {
        ...state,
        loading: true,
        suggestions: [],
        error: undefined,
      };
    case ACTIONS.COMPANY_SEARCH_RECEIVED:
      return {
        ...state,
        loading: false,
        suggestions: payload,
        error: undefined,
      };
    case ACTIONS.COMPANY_SEARCH_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
        suggestions: [],
      };

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./AutoComplete/context/reducer.js